import { RowCenter } from "style/preset";
import StyledContainer from "style/styledContainer";
import styled from "styled-components";

export const DrawerWinOneTileWrap = styled(StyledContainer)`
    margin-bottom: 12px;
    font-size: 22px;
    line-height: 22px;
    font-weight: 600;
    font-family: RoobertSemiBold
`

export const DrawerWinTwoTileWrap = styled(StyledContainer)`
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
`

export const CancelTextBtnWrap = styled(StyledContainer)`
    cursor: pointer;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    text-align: center;
    margin-top: 20px;
`

export const PaddingLeftRightWrap = styled(StyledContainer)`
    padding-left: 30px; 
    padding-right: 30px;
`

// 内容滚动相关
export const ScrollOutBoxWrap = styled(StyledContainer)`
    position: relative;
    height: calc(100% - 205px);
`

export const ScrollBoxWrap = styled(StyledContainer)`
    height: 100%;
    overflow:auto;
    padding: 0 30px;
`

export const ListTopGradientWrap = styled(StyledContainer)`
    height: 30px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
    z-index: 10;
`
export const ListBottomGradientWrap = styled(StyledContainer)`
    height: 30px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
    z-index: 10;
`
